class ToggleFiltersView extends HTMLElement {
  constructor() {
    super();
    this.filterOpened = false;
    this.addEventListener('click', this.handleClick.bind(this));
    if (this.dataset.enable === 'true') {  this.handleClick(); }
  }

  handleClick() {
    const section = this.closest('.shopify-section');
    const mainFilters = section?.querySelector('#main-collection-filters');
    const productGridContainer = section?.querySelector('#ProductGridContainer #product-grid');
    const title = this.querySelector('[btn-title]');
    if (!mainFilters || !productGridContainer) return;

    if (!this.filterOpened) {
      mainFilters.classList.add('active');
      mainFilters.style.setProperty('--max-width', `${mainFilters.scrollWidth + 40}px`);
      productGridContainer.classList.remove('grid--4-col-desktop');
      productGridContainer.classList.add('grid--3-col-desktop');
      title.textContent = 'Hide Filters'
    } else {
      mainFilters.classList.remove('active');
      mainFilters.style.setProperty('--max-width', '0px');
      productGridContainer.classList.remove('grid--3-col-desktop');
      productGridContainer.classList.add('grid--4-col-desktop');
      title.textContent = 'Filters'
    }

    this.filterOpened = !this.filterOpened;
  }
}

customElements.define('toggle-filters-view', ToggleFiltersView);